export const carouselItems = [
  {
    id: 1,
    title: '《咒术回战》第二季全资源上线',
    tag: '热播推荐',
    desc: '虎杖悠仁与伏黑惠的命运交织，涩谷事变篇章全面展开，全集高清资源已就绪，支持批量下载与离线缓存。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20illustration%20of%20Jujutsu%20Kaisen%20inspired%20dark%20fantasy%20scene%20with%20dynamic%20action%20pose%2C%20warm%20orange%20and%20crimson%20tones%2C%20Japanese%20urban%20fantasy%20aesthetic%2C%20professional%20anime%20key%20visual%20style%2C%20clean%20background%20with%20energy%20effects&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《鬼灭之刃》锻刀村篇全集',
    tag: '热门专题',
    desc: '炭治郎前往锻刀村修复日轮刀，与上弦之鬼的激战一触即发。全11集完整收录，支持一键批量下载和离线观看。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20illustration%20inspired%20by%20Demon%20Slayer%20with%20traditional%20Japanese%20village%20setting%2C%20warm%20firelight%20glow%2C%20swordsmith%20theme%2C%20rich%20red%20and%20orange%20color%20palette%2C%20professional%20anime%20key%20visual%20style&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《间谍过家家》第二季欢乐回归',
    tag: '人气新番',
    desc: '福杰一家的温馨日常与秘密任务继续上演，安妮亚的校园生活笑料不断。高清中日双语字幕版本即刻下载。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20warm%20family%20comedy%20scene%20with%20spy%20theme%2C%20elegant%20European%20city%20backdrop%2C%20soft%20golden%20lighting%2C%20clean%20and%20polished%20anime%20art%20style%2C%20professional%20key%20visual&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《葬送的芙莉莲》年度口碑神作',
    tag: '高分推荐',
    desc: '勇者小队归来后的漫长时光之旅，精灵魔法使芙莉莲重新认识生命的意义。细腻叙事与绝美画面，不可错过的治愈经典。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20of%20an%20elf%20mage%20in%20a%20peaceful%20fantasy%20landscape%20with%20soft%20golden%20sunset%2C%20pastoral%20fields%20and%20distant%20mountains%2C%20gentle%20atmospheric%20aesthetic%2C%20warm%20natural%20tones%2C%20professional%20anime%20illustration&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '《我推的孩子》现象级话题作',
    tag: '话题热议',
    desc: '演艺圈转生题材掀起全网讨论，星野爱的秘密与阿库亚的复仇之路。全网最速更新，日漫下载资源站内首发。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20idol%20culture%20themed%20scene%20with%20stage%20lights%20and%20glamorous%20atmosphere%2C%20modern%20Japanese%20entertainment%20aesthetic%2C%20vibrant%20magenta%20and%20gold%20tones%2C%20professional%20anime%20key%20visual%20style&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export const cardsItems = [
  {
    id: 1,
    title: '《电锯人》',
    tag: '暗黑热血',
    desc: '藤本树现象级漫画改编，电次与波奇塔的契约之战，血浆与泪水交织的黑色童话。全12话高清合集提供51动漫下载。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20chainsaw%20man%20inspired%20dark%20urban%20fantasy%20with%20red%20and%20black%20color%20scheme%2C%20dynamic%20action%20composition%2C%20gritty%20manga%20aesthetic%2C%20professional%20anime%20art%20style%2C%20clean%20minimal%20background&width=600&height=400&seq=cards-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《药屋少女的呢喃》',
    tag: '宫廷悬疑',
    desc: '猫猫在后宫中的药学推理之旅，精美古风画面与烧脑剧情完美融合。51动漫下载全集资源持续更新中。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20of%20a%20traditional%20Chinese%20palace%20setting%20with%20a%20female%20apothecary%20character%2C%20elegant%20classical%20aesthetic%2C%20warm%20amber%20and%20jade%20green%20tones%2C%20detailed%20period%20costume%2C%20professional%20anime%20illustration&width=600&height=400&seq=cards-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《迷宫饭》',
    tag: '美食冒险',
    desc: '在迷宫中烹饪魔物的硬核美食番，莱欧斯小队的另类生存指南。奇幻世界观与精致料理画面双重享受。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20fantasy%20dungeon%20cooking%20scene%20with%20adventurers%20preparing%20food%2C%20warm%20campfire%20lighting%2C%20whimsical%20fantasy%20aesthetic%2C%20rich%20earthy%20tones%2C%20professional%20anime%20art%20style&width=600&height=400&seq=cards-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《不死少女的谋杀闹剧》',
    tag: '推理悬疑',
    desc: '维多利亚时代的怪物推理剧，不死之身的侦探与鬼怪助手联手破案。独特的美术风格与巧妙的本格推理。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20of%20Victorian%20era%20mystery%20detective%20scene%20with%20gothic%20atmosphere%2C%20dark%20academia%20aesthetic%2C%20warm%20candlelight%20and%20shadow%2C%20elegant%20period%20costume%2C%20professional%20anime%20illustration&width=600&height=400&seq=cards-04&orientation=landscape',
  },
  {
    id: 5,
    title: '《杀手寓言》',
    tag: '黑色幽默',
    desc: '传奇杀手隐居大阪的搞笑日常，佐藤明的反差萌魅力无人能挡。硬派枪战与无厘头笑料完美平衡的佳作。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20stoic%20hitman%20character%20in%20modern%20Osaka%20street%20setting%2C%20contrast%20between%20danger%20and%20comedy%2C%20warm%20city%20night%20lighting%2C%20clean%20professional%20anime%20art%20style&width=600&height=400&seq=cards-05&orientation=landscape',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '《鬼灭之刃 无限城篇》剧场版PV',
    desc: '无限城决战正式揭幕，史上最华丽战斗场面即将呈现',
    tag: '剧场版预告',
    views: '128.6万',
    image: 'https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20style%20art%20with%20epic%20flame%20and%20water%20effects%2C%20Japanese%20warrior%20characters%20in%20dynamic%20battle%20pose%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20deep%20blue%20contrast%2C%20cinematic%20anime%20visual&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《咒术回战》涩谷事变MAD剪辑',
    desc: '五条悟vs漏瑚高燃混剪，年度最佳战斗作画集锦',
    tag: 'AMV·MAD',
    views: '96.3万',
    image: 'https://readdy.ai/api/search-image?query=Anime%20action%20scene%20with%20intense%20energy%20effects%20and%20urban%20destruction%2C%20dramatic%20lighting%20with%20purple%20and%20orange%20energy%2C%20dynamic%20fighting%20composition%2C%20professional%20anime%20art%20style&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《间谍过家家》安妮亚名场面合集',
    desc: '瓦库瓦库！安妮亚的可爱瞬间全程高能，治愈你的不开心',
    tag: '名场面集锦',
    views: '215.7万',
    image: 'https://readdy.ai/api/search-image?query=Cute%20anime%20character%20with%20pink%20hair%20in%20school%20setting%2C%20warm%20and%20cheerful%20atmosphere%2C%20soft%20pastel%20color%20palette%2C%20family%20comedy%20aesthetic%2C%20professional%20anime%20illustration&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《葬送的芙莉莲》旅途风景AMV',
    desc: '一人一杖的漫长旅途，每一帧都是壁纸级别的绝美画面',
    tag: 'AMV·风景',
    views: '87.2万',
    image: 'https://readdy.ai/api/search-image?query=Anime%20landscape%20art%20with%20lone%20traveler%20on%20a%20grassy%20path%20at%20sunset%2C%20rolling%20hills%20and%20distant%20mountains%2C%20warm%20golden%20hour%20lighting%2C%20atmospheric%20and%20peaceful%2C%20professional%20anime%20background%20art&width=640&height=360&seq=media-04&orientation=landscape',
  },
  {
    id: 5,
    title: '《我推的孩子》Yoasobi主题曲MV',
    desc: 'アイドル现象级主题曲官方MV，全网播放量突破5亿次',
    tag: '主题曲MV',
    views: '356.9万',
    image: 'https://readdy.ai/api/search-image?query=Anime%20idol%20performance%20stage%20with%20vibrant%20concert%20lighting%2C%20glamorous%20Japanese%20pop%20culture%20aesthetic%2C%20sparkling%20effects%20and%20dynamic%20composition%2C%20pink%20and%20gold%20color%20theme%2C%20professional%20anime%20illustration&width=640&height=360&seq=media-05&orientation=landscape',
  },
];

export const rankingItems = [
  { rank: 1, title: '鬼灭之刃 柱训练篇', tag: '日漫', heat: '🔥 爆', downloads: '累计 1,289,000+ 次', change: 'up' },
  { rank: 2, title: '咒术回战 第二季', tag: '日漫', heat: '🔥 爆', downloads: '累计 1,156,000+ 次', change: 'up' },
  { rank: 3, title: '我推的孩子', tag: '日漫', heat: '🔥 热', downloads: '累计 987,000+ 次', change: 'up' },
  { rank: 4, title: '葬送的芙莉莲', tag: '日漫', heat: '🔥 热', downloads: '累计 876,000+ 次', change: 'new' },
  { rank: 5, title: '间谍过家家 第二季', tag: '日漫', heat: '📈 升', downloads: '累计 765,000+ 次', change: 'up' },
  { rank: 6, title: '斗破苍穹 年番', tag: '国漫', heat: '📈 升', downloads: '累计 698,000+ 次', change: 'up' },
  { rank: 7, title: '完美世界', tag: '国漫', heat: '📈 升', downloads: '累计 654,000+ 次', change: 'new' },
];

export const contactData = {
  title: '投稿与合作',
  desc: '欢迎广大动漫爱好者、字幕组、汉化组与我们联系。无论你是想分享资源、提供建议，还是希望进行商务合作，我们都期待你的来信。51动漫网致力于打造最开放友好的动漫下载分享社区。',
  email: 'contact@51dongman.com',
  qq: '1234567890',
};

export const appData = {
  title: '51动漫 APP — 随身动漫资源库',
  desc: '下载51动漫官方APP，随时随地浏览海量动漫资源。支持离线缓存、智能推荐、夜间模式、倍速播放，让你的动漫体验更自由。覆盖日漫、国漫、韩漫全品类资源，每日更新不断档。',
  features: ['离线缓存随时看', '高清画质无压缩', '智能推荐更懂你', '夜间模式护眼', '新番更新提醒', '多设备同步记录'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20anime%20streaming%20app%20interface%20with%20colorful%20anime%20thumbnails%2C%20modern%20mobile%20UI%20design%2C%20dark%20theme%20with%20warm%20accent%20colors%2C%20clean%20professional%20app%20presentation%20on%20device%20screen&width=400&height=700&seq=app-01&orientation=portrait',
};

export const updatesItems = [
  {
    id: 1,
    date: '2026.07.28',
    tag: '资源更新',
    title: '《鬼灭之刃 无限城篇》剧场版高清资源已上线',
    desc: '无限城决战三部曲首部剧场版完整资源，支持1080P与4K双版本下载，内嵌中文字幕。',
  },
  {
    id: 2,
    date: '2026.07.26',
    tag: '新番上架',
    title: '2026年7月夏季新番专题页已更新',
    desc: '本季收录《咒术回战》续作、《黑执事》新篇等40+部新番，支持一站式批量下载。',
  },
  {
    id: 3,
    date: '2026.07.22',
    tag: '站点公告',
    title: '51动漫网离线下载功能全面升级',
    desc: '全新离线缓存引擎上线，下载速度提升300%，支持断点续传与后台下载。',
  },
  {
    id: 4,
    date: '2026.07.18',
    tag: '资源更新',
    title: '《葬送的芙莉莲》BD蓝光完整版发布',
    desc: '全28话BD蓝光版收录，含特典映像与评论音轨，画质全面提升。',
  },
  {
    id: 5,
    date: '2026.07.15',
    tag: '活动公告',
    title: '暑期动漫下载狂欢节火热进行中',
    desc: '活动期间每日精选10部经典动漫限时开放高速下载通道，不容错过。',
  },
  {
    id: 6,
    date: '2026.07.10',
    tag: '资源更新',
    title: '国漫专区新增《斗破苍穹》年番完整合集',
    desc: '萧炎三年之约篇至最新话全收录，支持中配与日配双音轨切换下载。',
  },
  {
    id: 7,
    date: '2026.07.05',
    tag: '站点公告',
    title: '韩漫资源专区正式上线',
    desc: '收录《我独自升级》《全知读者视角》等热门韩漫改编动画，持续扩充资源库。',
  },
  {
    id: 8,
    date: '2026.07.01',
    tag: '合作公告',
    title: '与多家字幕组达成官方合作',
    desc: '携手知名字幕组提供更高质量的中文字幕资源，确保翻译准确性与时效性。',
  },
];

export const commentsItems = [
  {
    id: 1,
    user: '二次元小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20avatar%20portrait%20with%20warm%20smile%2C%20simple%20clean%20background%2C%20chibi%20art%20style%2C%20cute%20and%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '3天前',
    content: '用了51动漫网三年了，资源全、更新快、下载稳定，真的找不到替代品。最近离线缓存功能升级后体验更好了，地铁上看番完全不卡！',
    rating: 5,
  },
  {
    id: 2,
    user: '追番达人小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20portrait%20with%20glasses%2C%20simple%20clean%20background%2C%20chibi%20art%20style%2C%20intelligent%20and%20warm%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '5天前',
    content: '国漫资源越来越全了！斗破苍穹、完美世界这些热门国漫日漫都能找到，字幕质量也很高。推荐给了好几个朋友都在用了。',
    rating: 5,
  },
  {
    id: 3,
    user: '深夜动画迷',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20avatar%20portrait%20with%20cool%20expression%20and%20headphones%2C%20simple%20clean%20background%2C%20chibi%20art%20style%2C%20modern%20casual%20look&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '1周前',
    content: '韩漫专区上线太惊喜了！《我独自升级》动画版资源全网首发就在这找到的。希望后续能加入更多韩漫改编作品的下载资源。',
    rating: 4,
  },
  {
    id: 4,
    user: '动漫考古学家',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20elder%20character%20avatar%20portrait%20with%20wise%20expression%2C%20simple%20clean%20background%2C%20chibi%20art%20style%2C%20friendly%20and%20knowledgeable%20look&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '2周前',
    content: '老番资源库真的牛，一些十几年前的冷门经典都能找到高清版本。这个网站对于补番党来说简直是天堂，收藏夹已经存了上百部了。',
    rating: 5,
  },
];

export const faqItems = [
  {
    id: 1,
    question: '51动漫网的资源都是免费下载的吗？',
    answer: '是的，51动漫网所有动漫资源均免费提供下载。我们致力于为动漫爱好者打造开放、免费的高清资源平台，支持日漫、国漫、韩漫等多品类资源的高速下载与离线缓存。无需注册或付费即可享受全部下载服务。',
  },
  {
    id: 2,
    question: '支持哪些清晰度的动漫下载？',
    answer: '51动漫网提供从720P到4K的多档清晰度选择，默认推荐1080P高清版本。部分热门作品同时提供HDR与杜比音效增强版本。你可以在每个资源详情页根据网络环境和存储空间自由选择最合适的清晰度进行下载。',
  },
  {
    id: 3,
    question: '下载的动漫有中文字幕吗？',
    answer: '站内所有动漫资源均内嵌高品质中文字幕，部分热门作品同时提供中日双语字幕版本。我们与多家知名字幕组建立了长期合作关系，确保字幕翻译的准确性与时效性，让你获得最佳的观看体验。',
  },
  {
    id: 4,
    question: '如何使用离线缓存功能？',
    answer: '离线缓存功能支持网页端和51动漫APP双端使用。网页端点击资源页面的"离线缓存"按钮即可将动漫保存到本地；APP端支持后台下载与断点续传，即使网络中断也不会丢失下载进度。缓存文件存储在本地设备，无需联网即可随时观看。',
  },
  {
    id: 5,
    question: '资源更新频率是怎样的？',
    answer: '51动漫网实行每日更新机制，新番播出后24小时内完成资源上架。热门连载作品同步日本播出进度更新，国漫年番保持每周定期更新。站内公告区会提前发布每周更新排期表，方便你安排追番计划。',
  },
];

export const topicsItems = [
  { id: 1, name: '鬼灭之刃', count: '128.6万', tag: 'hot' },
  { id: 2, name: '咒术回战', count: '115.2万', tag: 'hot' },
  { id: 3, name: '间谍过家家', count: '98.7万', tag: 'hot' },
  { id: 4, name: '我推的孩子', count: '89.3万', tag: 'trending' },
  { id: 5, name: '葬送的芙莉莲', count: '76.8万', tag: 'trending' },
  { id: 6, name: '斗破苍穹', count: '65.4万', tag: 'trending' },
  { id: 7, name: '电锯人', count: '58.2万', tag: '' },
  { id: 8, name: '迷宫饭', count: '47.6万', tag: '' },
  { id: 9, name: '完美世界', count: '42.1万', tag: '' },
  { id: 10, name: '药屋少女', count: '38.9万', tag: 'new' },
  { id: 11, name: '不死少女', count: '35.4万', tag: 'new' },
];

export const featuresItems = [
  {
    id: 1,
    icon: 'ri-download-cloud-2-line',
    title: '高速下载',
    desc: '多线程下载引擎，支持批量下载与断点续传，全速跑满你的带宽。离线缓存功能让你随时随地畅享动漫资源。',
  },
  {
    id: 2,
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '网页端、APP端数据实时同步，看番记录、收藏夹、下载列表跨设备无缝衔接，换设备不中断追番体验。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '安全无毒',
    desc: '所有资源经过严格安全检测，不含任何恶意程序或捆绑软件。下载文件均为纯净视频格式，保证你的设备安全。',
  },
  {
    id: 4,
    icon: 'ri-timer-flash-line',
    title: '极速更新',
    desc: '新番播出24小时内完成资源上架，热门作品同步日本进度。每日更新排期透明公开，追番不再焦虑等待。',
  },
];

export const indexItems = [
  {
    id: 1,
    title: '2026夏季新番合集',
    desc: '本季40+部新番一站收录，热门续作与黑马新作全覆盖',
    count: '40+部',
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20collage%20style%20with%20multiple%20character%20silhouettes%20in%20summer%20themed%20setting%2C%20vibrant%20and%20colorful%20composition%2C%20warm%20seasonal%20atmosphere%2C%20professional%20anime%20art%20style&width=400&height=250&seq=index-01&orientation=landscape',
  },
  {
    id: 2,
    title: '热血战斗专题',
    desc: '鬼灭、咒术、电锯人…拳拳到肉的顶级战斗作画收录',
    count: '200+部',
    image: 'https://readdy.ai/api/search-image?query=Anime%20action%20art%20with%20dynamic%20battle%20scene%20and%20energy%20effects%2C%20warm%20orange%20and%20red%20color%20palette%2C%20intense%20fighting%20composition%2C%20professional%20anime%20illustration%20style&width=400&height=250&seq=index-02&orientation=landscape',
  },
  {
    id: 3,
    title: '治愈日常精选',
    desc: '芙莉莲、间谍过家家、摇曳露营…温暖人心的慢生活动漫',
    count: '150+部',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20with%20peaceful%20slice%20of%20life%20scene%20in%20cozy%20countryside%20setting%2C%20soft%20warm%20sunlight%2C%20gentle%20pastoral%20aesthetic%2C%20calm%20and%20healing%20atmosphere%2C%20professional%20anime%20illustration&width=400&height=250&seq=index-03&orientation=landscape',
  },
  {
    id: 4,
    title: '国漫崛起专区',
    desc: '斗破苍穹、完美世界、凡人修仙传…国产动画精品力作合集',
    count: '180+部',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20fantasy%20scene%20with%20martial%20arts%20theme%2C%20traditional%20Chinese%20aesthetic%20with%20flowing%20robes%20and%20magical%20effects%2C%20warm%20golden%20and%20jade%20tones%2C%20professional%20donghua%20art&width=400&height=250&seq=index-04&orientation=landscape',
  },
  {
    id: 5,
    title: '悬疑推理剧场',
    desc: '不死少女、药屋少女、夏日重现…烧脑推理与反转剧情集结',
    count: '90+部',
    image: 'https://readdy.ai/api/search-image?query=Anime%20mystery%20themed%20illustration%20with%20dark%20academia%20aesthetic%2C%20Victorian%20era%20atmosphere%2C%20warm%20candlelight%20and%20shadow%20play%2C%20elegant%20and%20intriguing%20composition%2C%20professional%20anime%20art&width=400&height=250&seq=index-05&orientation=landscape',
  },
  {
    id: 6,
    title: '经典老番补全计划',
    desc: '从EVA到钢炼，跨越数十年的动漫经典一站式补完',
    count: '300+部',
    image: 'https://readdy.ai/api/search-image?query=Anime%20nostalgia%20themed%20art%20with%20retro%2090s%20anime%20aesthetic%2C%20warm%20film%20grain%20texture%2C%20classic%20cel%20animation%20style%2C%20sentimental%20and%20timeless%20feeling%2C%20professional%20illustration&width=400&height=250&seq=index-06&orientation=landscape',
  },
  {
    id: 7,
    title: '剧场版动画盛宴',
    desc: '新海诚、细田守、宫崎骏…大银幕级动画电影高清合集',
    count: '120+部',
    image: 'https://readdy.ai/api/search-image?query=Anime%20movie%20poster%20style%20art%20with%20cinematic%20wide%20landscape%2C%20dramatic%20sky%20and%20clouds%2C%20warm%20golden%20sunset%20lighting%2C%20epic%20and%20emotional%20atmosphere%2C%20professional%20anime%20film%20visual&width=400&height=250&seq=index-07&orientation=landscape',
  },
];

export const aboutData = {
  title: '关于51动漫网',
  desc: '51动漫网成立于2019年，是国内领先的免费动漫资源下载平台。我们专注于为动漫爱好者提供高品质、无广告的动漫下载服务，覆盖日漫、国漫、韩漫等多品类资源。\n\n经过多年发展，网站已收录超过5000部动漫作品，累计服务超过千万动漫爱好者。我们与多家字幕组保持紧密合作，确保资源更新速度与翻译质量始终处于行业领先水平。\n\n51动漫网始终坚持"免费、高速、安全"的服务理念。所有资源均经过严格安全检测，下载引擎持续优化，离线缓存功能让追番不再受网络限制。未来我们将继续拓展资源品类，为动漫社区创造更多价值。',
  stats: [
    { label: '收录作品', value: '5,000+' },
    { label: '累计用户', value: '1,200万+' },
    { label: '日均更新', value: '50+部' },
    { label: '合作字幕组', value: '30+' },
  ],
  image: 'https://readdy.ai/api/search-image?query=Anime%20community%20illustration%20with%20diverse%20anime%20characters%20gathered%20together%2C%20warm%20and%20welcoming%20atmosphere%2C%20colorful%20and%20vibrant%20composition%2C%20friendly%20community%20feeling%2C%20professional%20anime%20art%20style&width=500&height=350&seq=about-01&orientation=landscape',
};